import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Section, SectionHeading } from '../../components/ui/Layout';
import { ButtonLink } from '../../components/ui/Button';
import { applyPageMeta } from '../../utils/seo';

/**
 * Honest stand-in for surfaces whose data layer is complete but whose screens
 * are scheduled in a later phase. It states plainly what is not yet here rather
 * than presenting an empty page as finished.
 */
export function ComingNext({
  title,
  phase,
  detail
}: {
  title: string;
  phase: string;
  detail: string;
}) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    applyPageMeta({
      title: `${title} | Velnoris Executive Network`,
      description: detail,
      canonicalPath: pathname,
      noindex: true
    });
  }, [detail, pathname, title]);
  return <main id="main" data-id="element-683" data-mp="3fiwe8424vl25">
      <Section tone="parchment" data-id="element-684" data-mp="3ficwanchgwo4">
        <SectionHeading eyebrow={phase} title={title} as="h1" intro={detail} data-id="element-685" data-mp="3aj9xvlr0dop4" />
        <div className="mt-9 flex flex-wrap gap-3" data-id="element-686" data-mp="3ah6xq8w56f6o">
          <ButtonLink to="/" size="sm" data-id="element-687" data-mp="wc7oiu88yi8x">
            Return to the home page
          </ButtonLink>
          <ButtonLink to="/contact" size="sm" variant="secondary" data-id="element-688" data-mp="11bahvhev7012">
            Contact the firm
          </ButtonLink>
        </div>
      </Section>
    </main>;
}